module.exports = __webpack_public_path__ + "static/media/project4.f677f67f.png";